module.exports = __webpack_public_path__ + "img/map_suite-locations_hof.485f1b58.svg";